import { createStyles } from '@mantine/core'

export const useStyles = createStyles(() => ({
  label: {
    color: '#FAFAFA',
    fontWeight: 400,
  },
}))
